import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { openFileViewer } from '../../actions';

import HraGroupIcon from '../../images/hra/HraGroupIcon.png';
import HraCardIcon from '../../images/home/hra-card-icon.svg';
import reloadIcon from '../../images/home/reload-icon.svg';
import downloadIcon from '../../images/home/download-icon.svg';
import HraHeroIcon from '../../images/home/hra-hero-icon.svg';
import Background from '../../images/hra/background.svg';

const HRACard = ({ link }) => {
  const { dispatch } = useDispatch();
  const history = useHistory();
  return (
    <div className="p-4 border-b-2 border-txtsecondary-shades7">
      {link ? (
        <div className="border border-txtsecondary-shades7 rounded-12 pb-0">
          <div
            className="relative flex items-center justify-between border-b border-txtsecondary-shades7"
            style={{ height: '100px' }}
          >
            <img
              src={Background}
              style={{
                borderTopRightRadius: '10px',
                height: '100px',
              }}
              className="absolute bottom-0 right-0 rounded-tr-10px"
            />
            <img
              src={HraGroupIcon}
              className="absolute bottom-0 right-2 w-32"
            />
            <div
              style={{
                height: '100px',
                width: '195px',
              }}
              className="text-body-l font-semibold text-txtlight mt-1 absolute left-4 top-4"
            >
              Start your Health Risk Assessment Now!
            </div>
          </div>
          <button
            onClick={() => history.push('/hra')}
            className="w-full text-center py-3 text-primary font-bold text-button-m clickable"
          >
            Start Your Assessment
          </button>
        </div>
      ) : (
        <div className="border border-txtsecondary-shades7 rounded-12 p-16px px-0">
          <div className="flex px-16px mb-8px">
            <img src={HraCardIcon} alt="hra" className="self-start" />
            <p className="text-body-l font-semibold text-txtlight ml-8px">
              Health Risk Assessment
            </p>
          </div>
          <div
            className="flex justify-center items-center"
            style={{ borderBottom: '1px solid #f5f5f5' }}
          >
            <div className="px-16px">
              <p className="text-body-l text-sub">
                Download your HRA Report or Take HRA again
              </p>
            </div>
            <img src={HraHeroIcon} alt="hra-hero" className="px-16px" />
          </div>
          <div className="flex justify-around items-center mt-16px">
            <button
              className="flex justify-center items-center py-10px rounded-12"
              style={{ backgroundColor: '#EBEAF5', width: '40%' }}
              onClick={() => this.props.history.push('/hra/question')}
            >
              <img src={reloadIcon} alt="reload" />
              <p className="ml-6px text-body-l font-semibold text-icon">
                Retake HRA
              </p>
            </button>
            <button
              className="flex justify-center items-center py-10px bg-primary rounded-12"
              style={{ width: '40%' }}
              onClick={() =>
                dispatch(
                  openFileViewer({
                    contentUrl: link,
                    type: 'pdf',
                    title: 'HRA',
                  })
                )
              }
            >
              <img src={downloadIcon} alt="download" />
              <p className="ml-6px text-body-l font-semibold text-textbox">
                Download
              </p>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HRACard;
